const stats = [
  { value: '5000万+', label: '累计下载量', icon: 'ri-download-cloud-2-line' },
  { value: '36款', label: '精品游戏', icon: 'ri-gamepad-line' },
  { value: '99.9%', label: '安全稳定性', icon: 'ri-shield-check-line' },
  { value: '2000万+', label: '活跃用户', icon: 'ri-user-star-line' },
];

export default function StatsSection() {
  return (
    <section className="py-14 md:py-18 bg-primary-500">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-background-50/20 text-background-50 mb-3">
                <i className={`${stat.icon} text-lg`}></i>
              </div>
              <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading">{stat.value}</div>
              <div className="text-xs text-background-50/70 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}